<template>
  <div class="container" style="justify-content: center">
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <div class="row pt-3" style="justify-content: center">
          <div class="col-md-2" style="text-align: center; display: contents">
            <img
              src="/static/img/iconos/Riego2trazo-Smartcultivo.svg"
              style="height: 100px"
            />
          </div>
          <div class="col-md-10" style="text-align: center; display: contents">
            <span style="font-size: 20px">
              {{ dictionary.text_1 }}
              <br />
              {{ dictionary.text_2 }}
              <strong>{{ dictionary.text_3 }}</strong>
              {{ dictionary.text_4 }}
              <br />
              {{ dictionary.text_5 }} <strong>{{ dictionary.text_6 }}</strong>
              {{ dictionary.text_7 }}
            </span>
          </div>
        </div>
        <card class="shadow-lg">
          <div class="row content-add-btn">
            <div class="col-6-md">
              <button class="btn btn-secondary" @click="$router.go(-1)">
                <em class="fa fa-chevron-left"></em>
                {{ dictionary.btn_1 }}
              </button>
            </div>
            <div class="col-6-md">
              <img
                src="/static/img/languageIcons/bandera-de-espana.png"
                class="img-button-traslate-Es"
                @click="Es()"
                v-tooltip.top-center="'Español'"
              />
              <img
                src="/static/img/languageIcons/bandera-de-estados-unidos.png"
                class="img-button-traslate-En"
                @click="En()"
                v-tooltip.top-center="'English'"
              />
            </div>
          </div>
          <hr />
          <form-wizard
            ref="formWizard"
            v-if="this.isCreate() || this.isUpdate()"
            @on-complete="storeUpdateEngine"
            title
            subtitle
            :back-button-text="dictionary.btn_2"
            :next-button-text="dictionary.btn_3"
            :finish-button-text="dictionary.btn_4"
            class="custom-padding-wz-header"
          >
            <tab-content
              :title="dictionary.title_1"
              :before-change="() => validateStep('firstStep')"
            >
              <first-step
                ref="firstStep"
                :crops="crops"
                :farms="farms"
                @on-validated="onStepValidated"
                @fillWizardForm="fillWizardForm('firstStep')"
                @showHideLoading="showHideLoading"
              ></first-step>
            </tab-content>
            <tab-content
              :title="dictionary.title_2"
              :before-change="() => validateStep('secondStep')"
            >
              <second-step
                ref="secondStep"
                @on-validated="onStepValidated"
                @fillWizardForm="fillWizardForm('secondStep')"
                @showHideLoading="showHideLoading"
              ></second-step>
            </tab-content>
            <tab-content
              :title="dictionary.title_3"
              :before-change="() => validateStep('threeStep')"
            >
              <three-step
                ref="threeStep"
                @on-validated="onStepValidated"
                @fillWizardForm="fillWizardForm('threeStep')"
                @showHideLoading="showHideLoading"
              ></three-step>
            </tab-content>
          </form-wizard>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import SweetAlert from 'src/class/Alerts';
import FirstStep from './steps/FirstStep.vue';
import SecondStep from './steps/SecondStep.vue';
import ThreeStep from './steps/ThreeStep.vue';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinTranslate from 'src/util/mixinTranslate';
import { Axios } from 'src/class/Axios.js';
import MixinMenu from 'src/util/mixinMenu';

export default {
  components: {
    FirstStep,
    SecondStep,
    ThreeStep,
  },

  data() {
    return {
      globalDictionary: {},
      dictionary: {
        text_1: null,
        text_2: null,
        text_3: null,
        text_4: null,
        text_5: null,
        text_6: null,
        text_7: null,
        btn_1: null,
        btn_2: null,
        btn_3: null,
        btn_4: null,
        title_1: null,
        title_2: null,
        title_3: null,
      },
      model: {},
      wizardModel: {},
      crops: [],
      farms: [],
    };
  },

  mixins: [MixinPermissions, mixinMasters, MixinMenu, MixinTranslate],

  methods: {
    En() {
      this.dictionary = this.translateEn()['formCE'];
      this.globalDictionary = this.translateEn();
      sessionStorage.setItem(
        'globalDictionary',
        JSON.stringify(this.globalDictionary)
      );
      this.model.language = 'En';
      this.$refs.firstStep.En();
      this.$refs.secondStep.En();
      this.$refs.threeStep.En();
    },
    Es() {
      this.dictionary = this.translateEs()['formCE'];
      this.globalDictionary = this.translateEs();
      sessionStorage.setItem(
        'globalDictionary',
        JSON.stringify(this.globalDictionary)
      );
      this.model.language = 'Es';
      this.$refs.firstStep.Es();
      this.$refs.secondStep.Es();
      this.$refs.threeStep.Es();
    },
    cleanAllSteps() {
      this.$refs.firstStep.model = {};
      this.$refs.secondStep.model = {};
    },

    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model };
    },

    validateStep(ref) {
      return this.$refs[ref].validated();
    },

    fillWizardForm(ref) {
      this.wizardModel = Object.assign(
        {},
        this.wizardModel,
        this.$refs[ref].model
      );
    },

    storeUpdateEngine() {
      this.showHideLoading(true);
      this.wizardModel.email = sessionStorage.getItem('editForm')
        ? JSON.parse(sessionStorage.getItem('editForm')).email
        : '';
      this.wizardModel.route = 'climatenotification';
      this.wizardModel.language = sessionStorage.getItem('editForm')
        ? JSON.parse(sessionStorage.getItem('editForm')).language
        : '';
      Axios.saveMaster(this.wizardModel)
        .then((response) => {
          this.showHideLoading();
          this.forceRenderMenu();
          SweetAlert.prueba(response.data.message).then((result) => {
            if (result.value) {
              this.$router.push('/irrigation/form');
            }
          });
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.danger(error.response.data.message);
        });
    },
  },

  created() {
    if (sessionStorage.getItem('globalDictionary')) {
      this.dictionary = JSON.parse(
        sessionStorage.getItem('globalDictionary')
      ).formCE;
    } else {
      this.Es();
    }
    this.showHideLoading(true);
    if (this.isCreate() || this.isUpdate()) {
      Promise.all([
        Axios.getMasters('farms/farms/only'),
        Axios.getMasters('farms/crops'),
      ])
        .then((responses) => {
          this.farms = responses[0].data.data;
          this.crops = responses[1].data.data;
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else this.showHideLoading();
  },

  mounted() {
    this.selectedItemOnMenu('irrigation');
  },

  destroyed() {
    this.deselectedItemOnMenu('irrigation');
  },
  beforeDestroy() {
    sessionStorage.removeItem('editForm');
  },
};
</script>
<style>
.img-button-traslate-Es {
  width: 45px;
  cursor: pointer;
  border-radius: 50px;
  position: absolute;
  right: 10px;
}

.img-button-traslate-En {
  width: 45px;
  cursor: pointer;
  border-radius: 50px;
  position: absolute;
  right: 60px;
}

.wizard-card-footer div span[role='button'] button {
  white-space: inherit !important;
}
</style>
